<template>
    <el-button
        @click.stop="handleCopyBtn"
        :type="buttonType"
        class="copy-btn" v-dbclick
    >复制</el-button>
</template>

<script>
export default {
    name: 'CopyText',
    props: {
        text: {
            type: String,
            default: "复制成功了"
        },
        buttonType: {
            type: String,
            default: "text"
        }
    },

    data () {
        return {}
    },

    methods: {
        handleCopyBtn () {
            const fine = this.text.pushToClipBoard();
            if (fine) this.$message({
                message: "复制成功",
                type: "success"
            });
            else this.$message({
                message: "复制失败, 请手动复制",
                type: "warning"
            })
        }
    }
}
</script>